'use client'
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { seo } from '@/utils/seo';

const ClientSideEffects = () => {
    const pathname = usePathname();

    useEffect(() => {
        seo(pathname);
        localStorage.removeItem('lm_bmi_data');
    }, [pathname]);

    return null;
};

export default ClientSideEffects;
